import {S3_FULL_URL} from "../constants";

export function getFullImageUrl(image: string) {
  return `${S3_FULL_URL}${image}`
}
